<script>
import HamletTable from "@core/components/common/HamletTable.vue";
import Button from "@core/components/common/Button.vue";
import {BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {Button, HamletTable, BFormCheckbox},
    props: {
        properties: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            config: null,
            fetchCallback: null,
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-title'),
                },
                {
                    key: 'coveredExcluded',
                    class: 'text-center',
                    tdClass: 'text-center',
                    label: this.$t('Component(Grid):column-covered-excluded'),
                },
                {
                    key: 'actions',
                    class: 'text-center',
                    label: this.$t('Component(Grid):column-actions'),
                }
            ]
        }
    },
    methods: {
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;

            cb(
                this.properties.length,
                this.properties.slice(start, start + config.perPage)
            );
        },
        onTableCreated(config, cb, showLoader) {
            this.config = config;
            this.fetchCallback = cb;
        },
        selectProductStatement() {
            this.$refs.modal.show();
        },
        onProductStatementSelect(property) {
            this.$emit('newStatement', {
                property: property,
                coveredExcluded: false
            });
        },
        remove(property) {
            this.$emit('remove', property);
        },
        add() {
            this.$emit('add');
        }
    },
    watch: {
        properties() {
            this.fetch(this.config, this.fetchCallback);
        }
    }
}
</script>

<template>
    <div>
        <HamletTable
            :columns="columns"
            :fetch="fetch"
            :show-paging-when-empty="false"
            :show-empty-message="false"
            @created="onTableCreated"
        >
            <template #header-label>
                {{ title }}
            </template>
            <template #header-controls>
                <Button
                    class="mt-0 btn-icon"
                    @click="add"
                >
                    <feather-icon icon="PlusIcon" />
                </Button>
            </template>

            <template #cell-title="data">
                {{ data.item.property.title || data.item.property.productStatement }}
            </template>

            <template #cell-coveredExcluded="data">
                <b-form-checkbox
                    inline
                    switch
                    class="text-center"
                    v-model="data.item.coveredExcluded"
                />
            </template>

            <template #cell-actions="data">
                <div class="text-right">
                    <Button
                        class="btn-sm"
                        @click="remove(data.item)"
                    >
                        {{ $t('Component(Button):remove') }}
                    </Button>
                </div>
            </template>
        </HamletTable>
    </div>
</template>
